const { v4: uuidv4 } = require('uuid');

export default [
  {
    key: uuidv4(),
    name: null,
    fields: [
      {
        name: 'pin',
        label: 'PIN',
        type: 'number',
        validation: 'required|min:4|max:6',
        events: { appendClick: 'generatePIN' },
        appendIcon: 'mdi-reload',
        dense: true,
        outlined: true,
        hideDetails: true
      },
      {
        name: 'sonum',
        label: 'Sales Order',
        type: 'number',
        validation: 'required|numeric',
        dense: true,
        outlined: true,
        hideDetails: true
      },
      {
        name: 'ttl',
        label: 'TTL / minutes',
        type: 'number',
        placeholder: 'Minutes',
        validation: 'required|numeric|min:1|max:140',
        appendIcon: 'mdi-clock',
        default: 60,
        dense: true,
        outlined: true,
        hideDetails: true
      },
      {
        name: 'invalidatePrevPins',
        label: 'Invalidate Prev PINs for current sales order?',
        type: 'checkbox',
        default: false,
        dense: true,
        hideDetails: true
      }
    ]
  }
];
